




import { defineComponent, onMounted, nextTick } from '@vue/composition-api'
import { isString } from 'lodash-es';
import PageBuilderComponent from '~/mixins/solepro/PageBuilderComponent.vue';
import { ImageType } from '~/types/solepro/PageBuilder';
export default defineComponent({
    mixins: [PageBuilderComponent],
    props: {
        node: {
            type: Object,
            required: true
        },
    },
    computed: {
        renderHTML() {
            if (process.server) {
                //@ts-ignore
                return isString(this.node.DOMContent) ? this.node.DOMContent : this.node.DOMContent.outerHTML;  
            }

            //@ts-ignore
            return this.node.DOMContent;
        },
    },
    setup(props, context) {
        //props.node.DOMContent.querySelectorAll('img').forEach(el=>el.classList+=content.cssClasses)
        const content = props.node as ImageType;
        

        return {
            content
        }
    },
})
